var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMonday(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.92977 24.4999C3.23144 24.5019 2.54522 24.2688 1.94122 23.8247C1.33721 23.3806 0.837068 22.7412 0.491878 21.972C0.151954 21.2082 -0.0175791 20.3416 0.00144136 19.4651C0.0204618 18.5885 0.227319 17.7351 0.599852 16.9961L7.67962 2.90841C8.04196 2.15127 8.55642 1.52957 9.17044 1.10684C9.78446 0.684109 10.476 0.475488 11.1745 0.502293C11.8725 0.523462 12.5534 0.779239 13.1478 1.24344C13.7421 1.70765 14.2284 2.36362 14.5569 3.1442C15.2169 4.7255 15.1344 6.62797 14.344 8.11248L7.2687 22.2C6.90992 22.9085 6.41579 23.4908 5.83212 23.8928C5.24844 24.2949 4.59411 24.5037 3.92977 24.4999Z",
    fill: "#F62B54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9228 24.4998C14.4948 24.4998 13.1808 23.5324 12.4908 21.9776C12.1516 21.2159 11.9824 20.3516 12.0014 19.4773C12.0205 18.603 12.2269 17.7518 12.5987 17.0149L19.6653 2.95901C20.0223 2.1912 20.535 1.55843 21.1501 1.12633C21.7652 0.694236 22.4603 0.478562 23.1634 0.501681C24.6034 0.541555 25.9084 1.56217 26.5683 3.15885C26.8904 3.94068 27.037 4.81956 26.9921 5.69969C26.9471 6.57982 26.7123 7.42743 26.3134 8.15012L19.2483 22.2059C18.8906 22.9114 18.3985 23.4913 17.8173 23.8923C17.2361 24.2932 16.5846 24.502 15.9228 24.4998Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.5 24.5C29.433 24.5 31 22.4853 31 20C31 17.5147 29.433 15.5 27.5 15.5C25.567 15.5 24 17.5147 24 20C24 22.4853 25.567 24.5 27.5 24.5Z",
    fill: "#00CA72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonday);
export default __webpack_public_path__ + "static/media/ic_monday.b1b6c168c1d3598ee6a414de11913f4d.svg";
export { ForwardRef as ReactComponent };